export default "__VITE_ASSET__C8vdGD6o__"